module.exports = __webpack_public_path__ + "static/media/close-1.5308334d.svg";